var React = require('react');

function ArrowUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 4v18m8.005-12l-8-8-8 8","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

ArrowUpInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowUpInline;

ArrowUpInline.default = ArrowUpInline;
